import { queryOptions, useQuery } from '@tanstack/react-query'

import { supabase } from '../lib/supabase'

export const authQueryOptions = queryOptions({
  queryKey: ['auth-user'],
  queryFn: async () => {
    const {
      data: { user },
      error: authError,
    } = await supabase.auth.getUser()

    if (authError || !user) {
      return {
        user: null,
        role: null,
        tenant_id: null,
        name: null,
        is_active: true,
      }
    }

    const { data: profile, error: profileError } = await supabase
      .from('profiles')
      .select('name, email, is_active, role, tenant_id')
      .eq('id', user.id)
      .single()

    if (profileError) {
      console.error('Failed to fetch user profile:', profileError)
    }

    return {
      user,
      name: profile?.name || 'Usuário',
      email: profile?.email,
      role: profile?.role ?? user.app_metadata.role,
      tenant_id: profile?.tenant_id ?? user.app_metadata.tenant_id,
      is_active: profile?.is_active ?? true,
    }
  },
  staleTime: 1000 * 60 * 10, // Minutes
})

export function useAuth() {
  const { data, isLoading } = useQuery(authQueryOptions)

  return {
    user: data?.user ?? null,
    email: data?.email ?? null,
    name: data?.name ?? null,
    role: data?.role ?? null,
    tenantId: data?.tenant_id ?? null,
    isLoading,
    isActive: data?.is_active ?? true,
  }
}
